<template>
  <div class="createOrEditRoot">
    <div class="resourceFormPage divContainer configModule">
      <div v-if="loading" v-loading="loading" class="fullContainer" />
      <div v-else class="resourceFormPage__layout">
        <el-form
          ref="ruleForm"
          label-position="top"
          size="small"
          class="resourceFormPage__form"
          :model="ruleForm"
          :rules="rules"
          hide-required-asterisk
          @submit.native.prevent
        >
          <div class="resourceFormPage__headerDock">
            <header class="resourceFormPage__actionBar">
              <div class="resourceFormPage__lead">
                <h1 class="resourceFormPage__pageTitle">
                  {{ isCreate ? '新建 iOS 信息' : '编辑 iOS 信息' }}
                </h1>
              </div>
              <div class="resourceFormPage__actions">
                <button
                  type="button"
                  class="resourceFormPage__btn resourceFormPage__btn--ghost"
                  @click="goBack"
                >
                  取消
                </button>
                <button
                  type="button"
                  class="resourceFormPage__btn resourceFormPage__btn--primary"
                  :disabled="uploadLoading || buttonLoading"
                  @click="submitForm"
                >
                  {{ buttonLoading ? '保存中…' : '保存' }}
                </button>
              </div>
            </header>
          </div>

          <main class="resourceFormPage__main main configFormPage__main">
            <el-card class="card linkFormSection" data-section-id="basic">
              <div slot="header" class="linkFormSection__header">
                <strong class="linkFormSection__title">基本信息</strong>
              </div>

              <div class="linkFormBasic">
                <div class="linkFormBasic__media">
                  <div class="linkFormMediaAnchor">
                    <el-image
                      v-if="ruleForm.iconUrl"
                      class="linkFormMediaAnchor__preview"
                      :src="ruleForm.iconUrl"
                      :preview-src-list="[ruleForm.iconUrl]"
                      fit="cover"
                    >
                      <div slot="error" class="linkFormMediaAnchor__previewFallback">
                        <i class="el-icon-picture-outline" aria-hidden="true" />
                      </div>
                    </el-image>
                    <button
                      v-else
                      type="button"
                      class="linkFormUploadZone linkFormUploadZone--anchor"
                      :disabled="uploadLoading"
                      @click="triggerIconUpload"
                    >
                      <i class="el-icon-upload2 linkFormUploadZone__icon" aria-hidden="true" />
                      <span>{{ uploadLoading ? '上传中…' : '上传 Icon' }}</span>
                      <span class="linkFormUploadZone__hint">支持常见图片格式</span>
                    </button>
                  </div>

                  <div v-if="ruleForm.iconUrl" class="linkFormMediaFileBar">
                    <span class="linkFormMediaFileBar__name">应用 Icon</span>
                    <div class="linkFormMediaFileBar__actions">
                      <button
                        type="button"
                        class="linkFormMediaFileBar__btn"
                        :disabled="uploadLoading"
                        @click="triggerIconUpload"
                      >
                        替换
                      </button>
                      <button
                        type="button"
                        class="linkFormMediaFileBar__btn linkFormMediaFileBar__btn--danger"
                        @click="clearIcon"
                      >
                        移除
                      </button>
                    </div>
                  </div>

                  <el-upload
                    ref="iconUpload"
                    class="configFormPage__hiddenUpload"
                    action="/"
                    accept="image/*"
                    :http-request="customRequest"
                    :show-file-list="false"
                  />
                  <el-form-item prop="iconUrl" class="linkFormBasic__urlField">
                    <el-input v-show="false" v-model="ruleForm.iconUrl" />
                  </el-form-item>
                </div>

                <div class="linkFormBasic__fields configFormPage__fields">
                  <el-form-item
                    class="configFormPage__field--wide"
                    label="Title"
                    prop="title"
                  >
                    <el-input
                      v-model="ruleForm.title"
                      placeholder="请输入 title"
                      clearable
                    />
                  </el-form-item>
                  <el-form-item
                    class="configFormPage__field--wide"
                    label="Target"
                    prop="target"
                  >
                    <el-input
                      v-model="ruleForm.target"
                      placeholder="请输入 target"
                      clearable
                    />
                  </el-form-item>
                  <el-form-item
                    class="configFormPage__field--wide"
                    label="Comment"
                    prop="comment"
                  >
                    <el-input
                      v-model="ruleForm.comment"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入 comment"
                    />
                  </el-form-item>
                </div>
              </div>
            </el-card>
          </main>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { getAppById, createApp, editApp } from '../../../api/iosAppInfo'
import { uploadFile } from '../../../api/comment'

export default {
  name: 'IosAppInfoCreateOrEdit',
  data() {
    return {
      isCreate: true,
      ruleForm: {
        title: '',
        target: '',
        iconUrl: '',
        comment: '',
      },
      loading: false,
      buttonLoading: false,
      rules: {
        title: [{ required: true, message: 'title不能为空', trigger: 'blur' }],
        target: [{ required: true, message: 'target不能为空', trigger: 'blur' }],
        iconUrl: [{ required: true, message: 'icon不能为空', trigger: 'change' }],
        comment: [{ required: true, message: 'comment不能为空', trigger: 'blur' }],
      },
      uploadLoading: false,
    }
  },
  created() {
    this.isCreate = this.$route.path.indexOf('edit') === -1
    if (!this.isCreate) {
      this.getData()
    }
  },
  methods: {
    triggerIconUpload() {
      const upload = this.$refs.iconUpload
      if (upload && upload.$refs['upload-inner'] && upload.$refs['upload-inner'].$refs.input) {
        upload.$refs['upload-inner'].$refs.input.click()
      }
    },
    clearIcon() {
      this.ruleForm.iconUrl = ''
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.validateField('iconUrl')
        }
      })
    },
    customRequest(params) {
      this.uploadLoading = true
      const file = new FormData()
      file.append('file', params.file)
      uploadFile(file)
        .then((res) => {
          if (res.success) {
            this.ruleForm.iconUrl = res.data
            this.$nextTick(() => {
              if (this.$refs.ruleForm) {
                this.$refs.ruleForm.validateField('iconUrl')
              }
            })
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
        .finally(() => {
          this.uploadLoading = false
        })
      return false
    },
    getData() {
      this.loading = true
      getAppById({ id: this.$route.params.id })
        .then((res) => {
          if (res.success) {
            this.ruleForm = res.data
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          this.$message.error('你还有参数没有填完整')
          return false
        }
        this.buttonLoading = true
        const request = this.isCreate
          ? createApp(this.ruleForm)
          : editApp(this.ruleForm)
        request
          .then((res) => {
            if (res.success) {
              this.$message.success(this.isCreate ? '新增成功!' : '编辑成功!')
              this.$router.push('/config/iosAppInfo/list')
            }
          })
          .catch((err) => {
            this.$message.error(err)
          })
          .finally(() => {
            this.buttonLoading = false
          })
      })
    },
    goBack() {
      this.$router.push('/config/iosAppInfo/list')
    },
  },
}
</script>

<style scoped>
.createOrEditRoot,
.fullContainer {
  height: 100%;
}

.resourceFormPage__form {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
</style>

<style>
.configModule.divContainer {
  min-height: 100%;
  background: var(--link-canvas);
}

.configModule .main {
  background: transparent;
}
</style>
